import { BookApi } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    books: [],
    book: {},
    reportBooks: [],
  },
  actions: {
    async createBook(_, data) {
      await BookApi.create(data)
    },
    async fetchBooks({ commit }, params) {
      const res = await BookApi.fetch({ ...params })
      commit('setBooks', res)
      return res
    },
    async fetchBook({ commit }, id) {
      const res = await BookApi.fetchOne(id)
      commit('setBook', res)
      return res
    },
    resetBook({ commit }) {
      commit('resetBook')
    },
    async reportLostBook(_, { id, data }) {
      await BookApi.reportLostBook(id, data)
    },
    async reportBook({ commit }, id) {
      const res = await BookApi.fetchBookHistory({ book: id })
      commit('setReportBook', res)
      return res
    },
  },
  mutations: {
    setBooks(state, payload) {
      state.books = payload
    },
    setBook(state, payload) {
      state.book = payload
    },
    resetBook(state) {
      state.book = {}
    },
    setReportBook(state, payload) {
      state.reportBooks = payload
    },
  },
}
